/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-09-19 11:18:37
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-02-10 17:40:45
 * @FilePath: \ioc_base\src\modules\reserve\const\table.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import utils from "@src/common/utils";
import store from "@src/common/lib/store";
import i18n from "@src/common/lib/i18n";
import { Dic, Cache } from "$utils";
const tableOption = function (that) {
  return {
    page: true,
    selection: false,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    // calcHeight: 100,
    menuWidth: 200,
    index: true,
    labelWidth: "100px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: "955px",
    emptyText: "暂无数据",
    column: [
      {
        label: "预案名称",
        prop: "emergencyPlanName",
        search: true,
        clearable: true
      },
      {
        label: "预案分类",
        prop: "subSystemList",
        search: false,
        dicData: Dic.find("SENU073005"),
        formatter: function (row, value) {
          return value
            .map((item) => {
              return Dic.findByValue("SENU073005", item);
            })
            .join(" | ");
        },
        span: 12
      },
      {
        label: "预案状态",
        prop: "status",
        search: true,
        type: "select",
        viewslot: true,
        dicData: [
          { label: "启用", value: 1 },
          { label: "禁用", value: 0 }
        ],
        formatter: function (row, value) {
          let str = "";
          if (value == 1) {
            str = "未启动";
          }
          if (value == 2) {
            str = "执行中";
          }
          if (value == 3) {
            str = "已完成";
          }
          return str;
        },
        span: 12
      },
      {
        label: "创建人",
        prop: "creator",
        span: 12
      },
      {
        label: "创建时间",
        prop: "createTime",
        span: 12
      }
    ]
  };
};
export default tableOption;
